import React from "react";
import { Link } from "react-router-dom";
import { Building2, Mail, Phone, MapPin, ShieldCheck, FileText } from "lucide-react";

export default function ImpressumPage() {
  return (
    <div className="pt-32 pb-24 bg-slate-50 min-h-screen" data-testid="impressum-page">
      <div className="mbw-container max-w-4xl">
        <div className="mbw-overline mb-4">Rechtliches</div>
        <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-tighter text-[#1A2433] leading-[1.02] mb-10">
          Impressum
        </h1>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-slate-200 space-y-10">
          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4 flex items-center gap-2">
              <Building2 className="w-5 h-5 text-[#991B1B]" /> Anbieter
            </h2>
            <div className="text-slate-700 leading-relaxed space-y-1">
              <div className="font-semibold text-[#1A2433]">MBW Swiss AG</div>
              <div>Wildenstrasse 3</div>
              <div>CH-8212 Neuhausen am Rheinfall</div>
              <div>Schweiz</div>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4 flex items-center gap-2">
              <Phone className="w-5 h-5 text-[#991B1B]" /> Kontakt
            </h2>
            <ul className="text-slate-700 leading-relaxed space-y-2">
              <li>
                <Phone className="w-4 h-4 inline mr-2 text-slate-400" />
                <a href="tel:+41525510140" className="hover:text-[#991B1B]">+41 52 551 01 40</a>
              </li>
              <li>
                <Mail className="w-4 h-4 inline mr-2 text-slate-400" />
                <a href="mailto:office@mbw-swiss.ch" className="hover:text-[#991B1B]">office@mbw-swiss.ch</a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4">
              Handelsregister
            </h2>
            <p className="text-slate-700 leading-relaxed">
              Eingetragen im Handelsregister des Kantons Schaffhausen.<br />
              UID-Nummer: <strong>CHE-107.981.530</strong>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4">
              Mehrwertsteuer
            </h2>
            <p className="text-slate-700 leading-relaxed">
              MWST-Nummer: <strong>CHE-107.981.530 MWST</strong>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4">
              Vertretungsberechtigte Person
            </h2>
            <p className="text-slate-700 leading-relaxed">
              <strong>Matthias Kirchner</strong>, Verwaltungsrat
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4 flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-[#991B1B]" /> Berufshaftpflichtversicherung
            </h2>
            <p className="text-slate-700 leading-relaxed">
              Details zur Berufshaftpflichtversicherung (Versicherer, Deckungssumme,
              räumlicher Geltungsbereich) erhalten Sie auf Anfrage an
              {" "}<a href="mailto:office@mbw-swiss.ch" className="text-[#991B1B] hover:underline">office@mbw-swiss.ch</a>.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4">
              Streitbeilegung
            </h2>
            <p className="text-slate-700 leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4">
              Haftungsausschluss
            </h2>
            <p className="text-slate-700 leading-relaxed">
              Die Inhalte dieser Website wurden mit grösstmöglicher Sorgfalt erstellt. Für die
              Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine
              Gewähr übernehmen. Die Nutzung der Website-Inhalte erfolgt auf eigene Gefahr.
              Namentlich gekennzeichnete Beiträge geben die Meinung des Verfassers wieder und
              decken sich nicht zwangsläufig mit der Auffassung des Anbieters.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-[#1A2433] mb-4">
              Urheberrechte
            </h2>
            <p className="text-slate-700 leading-relaxed">
              Sämtliche Inhalte dieser Website (Texte, Bilder, Logos, Grafiken) sind urheberrechtlich
              geschützt. Eine Vervielfältigung oder Verwendung in anderen elektronischen oder
              gedruckten Publikationen ist ohne ausdrückliche Zustimmung der MBW Swiss AG nicht
              gestattet.
            </p>
          </section>

          <p className="text-xs text-slate-400 pt-6 border-t border-slate-200">
            Stand: {new Date().toLocaleDateString("de-CH", { year: "numeric", month: "long" })}
          </p>
        </div>

        {/* ----------------------- AGB ----------------------- */}
        <div id="agb" className="bg-white rounded-2xl p-8 md:p-12 border border-slate-200 mt-12 scroll-mt-32" data-testid="agb-section">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-11 h-11 rounded-lg bg-[#1A2433] flex items-center justify-center flex-shrink-0">
              <FileText className="w-5 h-5 text-[#DC2626]" />
            </div>
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A2433] tracking-tight leading-tight">
                Allgemeine Geschäftsbedingungen
              </h2>
              <p className="text-sm text-slate-500 mt-1">
                Für Treuhand- &amp; Gründungsdienstleistungen · <strong>Version 1.0 · Stand: Februar 2026</strong>
              </p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed space-y-6">
            <AgbItem n="1" title="Geltungsbereich">
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für sämtliche Dienstleistungen
              der MBW Swiss AG, insbesondere Beratungs-, Treuhand-, Gründungs-, Koordinations-
              und Supportleistungen im Zusammenhang mit Unternehmensgründungen in der Schweiz.
              Abweichende Vereinbarungen bedürfen der schriftlichen Form.
            </AgbItem>

            <AgbItem n="2" title="Vertragsverhältnis">
              Das Vertragsverhältnis kommt durch schriftliche oder elektronische Annahme eines
              Angebots, Vertrags oder durch tatsächliche Inanspruchnahme von Leistungen zustande.
              Die Beraterin ist berechtigt, Aufträge ohne Angabe von Gründen abzulehnen.
            </AgbItem>

            <AgbItem n="3" title="Leistungsumfang">
              Der Leistungsumfang ergibt sich <strong>ausschliesslich</strong> aus dem individuell
              vereinbarten Vertrag oder Auftrag. Allgemeine Beschreibungen, Webseiteninhalte oder
              Gespräche stellen keine verbindliche Leistungspflicht dar.
            </AgbItem>

            <AgbItem n="4" title="Drittleistungen">
              Die Beraterin kann zur Leistungserbringung Dritte beiziehen (z. B. Banken, Notare,
              Behörden, Treuhänder, Übersetzer). Für Leistungen dieser Dritten übernimmt die
              Beraterin keine Verantwortung.
            </AgbItem>

            <AgbItem n="5" title="Mitwirkungspflichten">
              Der Kunde verpflichtet sich zur vollständigen und rechtzeitigen Mitwirkung.
              Verzögerungen durch fehlende oder falsche Angaben gehen zulasten des Kunden.
            </AgbItem>

            <AgbItem n="6" title="Keine Erfolgsgarantie">
              Es wird ausdrücklich keine Garantie für wirtschaftlichen Erfolg, Steuerfolgen,
              Bewilligungen, Kontoeröffnungen oder Handelsregistereintragungen übernommen.
            </AgbItem>

            <AgbItem n="7" title="Haftung">
              <p>
                Jegliche Haftung der Beraterin wird im gesetzlich zulässigen Rahmen vollständig
                ausgeschlossen. Insbesondere wird keine Haftung übernommen für:
              </p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Entscheidungen von Banken, Notaren oder Behörden</li>
                <li>Ablehnungen von Gründungen oder Kontoeröffnungen</li>
                <li>rechtliche oder steuerliche Folgen im In- oder Ausland</li>
                <li>Informationen von Dritten</li>
                <li>Verzögerungen im Gründungsprozess</li>
                <li>Fehler aufgrund unvollständiger oder falscher Kundenangaben</li>
              </ul>
              <p className="mt-3">
                Die Haftung ist – soweit gesetzlich zwingend nicht ausgeschlossen – auf
                vorsätzliches Verhalten beschränkt. Eine Haftung für leichte und mittlere
                Fahrlässigkeit wird ausgeschlossen. Die Haftung ist in jedem Fall auf die vom
                Kunden im jeweiligen Mandat bezahlte Vergütung beschränkt. Der Kunde bestätigt,
                dass sämtliche Entscheidungen im Zusammenhang mit der Gründung eigenverantwortlich
                erfolgen und die Beraterin <strong>ausschliesslich</strong> unterstützend tätig ist.
              </p>
            </AgbItem>

            <AgbItem n="8" title="Vergütung">
              Alle Preise verstehen sich zzgl. MWST und externer Kosten. Die Beraterin ist berechtigt,
              Vorauszahlungen zu verlangen. Eine ausführliche Übersicht der aktuellen Tarife finden
              Sie in unserer <Link to="/preisliste" className="text-[#991B1B] underline hover:no-underline">Preisliste</Link>.
            </AgbItem>

            <AgbItem n="9" title="Zahlungsbedingungen">
              Rechnungen sind sofort oder gemäss individueller Vereinbarung fällig. Bei
              Zahlungsverzug kann die Leistungserbringung eingestellt werden.
            </AgbItem>

            <AgbItem n="10" title="Geldwäscherei / Compliance">
              Die Beraterin ist berechtigt, Mandate jederzeit abzulehnen oder abzubrechen,
              insbesondere bei Compliance-, Sanktions- oder Reputationsrisiken.
            </AgbItem>

            <AgbItem n="11" title="Datenschutz">
              Es gilt das schweizerische Datenschutzrecht. Daten dürfen an Dritte weitergegeben
              werden, soweit dies zur Vertragserfüllung erforderlich ist. Details zur Verarbeitung
              personenbezogener Daten entnehmen Sie unserer
              {" "}<Link to="/datenschutz" className="text-[#991B1B] underline hover:no-underline">Datenschutzerklärung</Link>.
            </AgbItem>

            <AgbItem n="12" title="Salvatorische Klausel">
              Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder
              werden, so bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt. An die
              Stelle der unwirksamen Bestimmung tritt diejenige zulässige Regelung, die dem
              wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
            </AgbItem>

            <AgbItem n="13" title="Gerichtsstand / Recht">
              Es gilt <strong>ausschliesslich</strong> schweizerisches Recht. Ausschliesslicher
              Gerichtsstand für sämtliche Streitigkeiten aus oder im Zusammenhang mit diesen AGB
              und dem zugrunde liegenden Mandatsverhältnis ist <strong>Schaffhausen, Schweiz</strong>.
            </AgbItem>
          </div>

          <p className="text-xs text-slate-400 pt-6 border-t border-slate-200 mt-10">
            MBW Swiss AG · Wildenstrasse 3 · 8212 Neuhausen am Rheinfall ·
            Version 1.0 · Stand: Februar 2026
          </p>
        </div>
      </div>
    </div>
  );
}

function AgbItem({ n, title, children }) {
  return (
    <section data-testid={`agb-item-${n}`}>
      <h3 className="font-heading text-lg font-bold text-[#1A2433] mb-2 flex items-baseline gap-3">
        <span className="text-[#991B1B] tabular-nums">{n}.</span>
        <span>{title}</span>
      </h3>
      <div className="text-slate-700 leading-relaxed pl-7">{children}</div>
    </section>
  );
}
